import jsPDF from "jspdf";
import "../services/LiberationSerif-Regular-normal";

export default function exportPDF(columns, data) {
  const unit = "pt";
  const size = "A4"; // Use A1, A2, A3 or A4
  const orientation = "landscape"; // portrait or landscape
  const doc = new jsPDF(orientation, unit, size);

  doc.setFont("LiberationSerif-Regular");

  const filteredColumns = columns.filter(
    (c) => typeof c.field === "string" && typeof c.title === "string"
  );
  const fields = filteredColumns.map((c) => c.field);
  let exportedData = [];

  const createContent = (exportedData) => {

    return ({
      startY: 50,
      head: [filteredColumns],
      body: [...exportedData.map((row) => fields.map((f) => row[f]))],
      styles: {
        font: "normal",
        overflow: "linebreak",
        lineWidth: 1,
      },
      headStyles: { font: "LiberationSerif-Regular", fontStyle: "normal" },
      bodyStyles: { font: "LiberationSerif-Regular", fontStyle: "normal" },
    });
  };

  if (data[0].data === undefined) {
    exportedData = data;
    doc.autoTable(createContent(exportedData));
  } else {
    exportedData = data.map((data) => {
      return { data: data.data, value: data.value };
    });
    for (let i = 0; i < exportedData.length; i++) {
      doc.text(`${exportedData[i].value}`, 14, 30);
      doc.autoTable(createContent(exportedData[i].data));
      doc.addPage();
    }
  }

  doc.setFontSize(40);
  doc.save("report.pdf");
}
